"use client";
import Link from "next/link";
import Autoplay from "embla-carousel-autoplay";
import React from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import Image from "next/image";

const Jumbotron = () => {
  return (
    <>
      <section className="relative">
        <Carousel
          className="absolute inset-0 w-full h-full object-cover"
          plugins={[
            Autoplay({
              delay: 3000,
            }),
          ]}
        >
          <CarouselContent>
            <CarouselItem className="p-0">
              <Image
                alt=""
                src={`${process.env.NEXT_PUBLIC_AKREDITASI_UI_URL}/newimage.jpg`}
                width={2560}
                height={1440}
                className="object-cover w-screen h-screen "
              />
            </CarouselItem>
            <CarouselItem className=" p-0">
              <Image
                alt=""
                src={`${process.env.NEXT_PUBLIC_AKREDITASI_UI_URL}/newimage2.jpg`}
                width={2560}
                height={1440}
                className="object-cover w-screen h-screen"
              />
            </CarouselItem>
            <CarouselItem className="p-0">
              <Image
                alt=""
                src={`${process.env.NEXT_PUBLIC_AKREDITASI_UI_URL}/newimage3.jpg`}
                width={2560}
                height={1440}
                className="object-cover w-screen h-screen"
              />
            </CarouselItem>
          </CarouselContent>
        </Carousel>
        <div className="relative w-full h-screen">
          <div className="size-full bg-customDarkBlue/90 ">
            <div className="max-w-screen-xl px-4 py-24 mx-auto lg:py-56">
              <h1 className="mb-4 text-2xl font-extrabold leading-none tracking-tight text-white md:text-5xl lg:text-6xl">
                Akreditasi Program Pelatihan Teknis
              </h1>
              <h1 className="mb-4 text-2xl font-extrabold leading-none tracking-tight text-white md:text-5xl lg:text-6xl">
                Di Bidang Keuangan Negara
              </h1>
              <p className="mb-8 text-lg font-normal text-gray-300 ">
                BPPK diberikan mandat untuk menjaminkan mutu pelatihan pelatihan
                teknis di Bidang Keuangan Negara bagi ASN dan memiliki
                kewenangan untuk memberikan dan mencabut Akreditasi terhadap
                program pelatihan teknis di Bidang Keuangan Negara yang
                diselenggarakan oleh Lembaga Pelatihan Pemerintah (LPP).
              </p>
              <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0">
                <a
                  href="akreditasi/mitra"
                  className="inline-flex px-5 py-3 text-base font-medium text-center text-white bg-orange-600 rounded-lg hover:bg-orange-700 focus:ring-4 "
                >
                  Ajukan Akreditasi
                  <svg
                    className="w-3.5 h-3.5 ms-2 rtl:rotate-180 self-center"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </a>
                <a
                  href="#"
                  className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white border border-white rounded-lg hover:text-customOrange sm:ms-4 hover:bg-gray-100 focus:ring-4 focus:ring-gray-400"
                >
                  Learn more
                </a>
              </div>
            </div>
            <div className="circlePosition w-[120px] h-[100px] bg-customOrange rounded-full absolute z-1 top-[140%] sm:top-[18%]  left-[2%] translate-x-[-50%] translate-y-[-50%] blur-[90px]"></div>
            <div className="circlePosition w-[320px] h-[200px] bg-customOrange rounded-full absolute z-0 top-[40%] sm:top-[98%]  right-[2%] translate-x-[-50%] translate-y-[-50%] blur-[90px] opacity-30"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jumbotron;
